module.exports = __webpack_public_path__ + "static/media/AngelsOfAether-Gallery-20.ae4c3213.jpg";